const WEB3FORMS_URL = "https://api.web3forms.com/submit";

function accessKey() {
  const v = process.env.VUE_APP_WEB3FORMS_ACCESS_KEY;
  return typeof v === "string" ? v.trim() : "";
}

function turnstileSiteKey() {
  const v = process.env.VUE_APP_TURNSTILE_SITE_KEY;
  return typeof v === "string" ? v.trim() : "";
}

export function isContactEmailConfigured() {
  return Boolean(accessKey());
}

/** إن وُجد مفتاح الموقع في .env يُفعَّل التحقق ويُرسل رمز Turnstile مع الطلب إلى Web3Forms */
export function isTurnstileConfigured() {
  return Boolean(turnstileSiteKey());
}

function normalizeCountry(country) {
  if (country == null) return "";
  if (typeof country === "string") return country;
  return country.name || country.Name || String(country);
}

/**
 * إرسال نموذج التواصل عبر Web3Forms (مجاني، بدون مكتبة — طلب fetch عادي).
 * أنشئ مفتاحاً من https://web3forms.com واضبط البريد المستقبل عند التسجيل.
 */
export function sendContactFormEmail({
  name,
  email,
  country,
  subject,
  message,
  turnstileToken,
}) {
  const key = accessKey();
  if (!key) {
    return Promise.reject(
      new Error("Missing env VUE_APP_WEB3FORMS_ACCESS_KEY")
    );
  }

  const tsKey = turnstileSiteKey();
  if (tsKey) {
    const token =
      typeof turnstileToken === "string" ? turnstileToken.trim() : "";
    if (!token) {
      return Promise.reject(new Error("Turnstile verification required"));
    }
  }

  const countryStr = normalizeCountry(country);
  const payload = {
    access_key: key,
    subject: `[موقع تخطي — تواصل] ${subject}`,
    name,
    email,
    replyto: email,
    country: countryStr,
    message: message ?? "",
  };

  if (tsKey) {
    const token =
      typeof turnstileToken === "string" ? turnstileToken.trim() : "";
    payload["cf-turnstile-response"] = token;
  }

  return fetch(WEB3FORMS_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    let data = {};
    try {
      data = await response.json();
    } catch {
      /* ignore */
    }
    if (!response.ok || data.success === false) {
      const err =
        data.message || data.error || response.statusText || "فشل الإرسال";
      throw new Error(err);
    }
    return data;
  });
}
